import { createReducer, on } from "@ngrx/store";
import { RehydrateOptions } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { SportsbookBlockAction } from "./sportsbook-block.action";
import { SportsbookBlockState } from "./sportsbook-block.model";

const INITIAL_STATE: SportsbookBlockState = {};
const rehydrateOptions: RehydrateOptions<SportsbookBlockState> = {
	name: "sportsbookBlockReducer",
	excludeProps: ["isSportsbookBlocked", "isPlayerProfileSelected"],
};

export const sportsbookBlockReducer = createReducer(
	INITIAL_STATE,
	on(SportsbookBlockAction.update, (state, { sportsbookBlockUpdate }) => updateState(state, sportsbookBlockUpdate)),
	on(SportsbookBlockAction.postpone, (state) => updateState(state, { isSelectionPostponed: true })),
	on(SportsbookBlockAction.clear, () => INITIAL_STATE)
);

sportsbookBlockReducer.prototype.rehydrateOptions = rehydrateOptions;
